/**
 * Card
 */

// Module dependencies
import 'protons';
import 'atoms/image';
import 'atoms/button';
import $ from 'jquery';

// Module template
import './_card.twig';

// Module styles
import './_card.scss';

export const name = 'card';

export function disable() {}

export function enable() {}

$(document).ready(() => {
  const RESIZE_DEBOUNCE_INTERVAL = 300;
  const $cards = $('.cta-cards .card');
  const responsive = window.matchMedia('(min-width: 768px)');
  let heights;
  let resizeTimer;

  function getMaxOfArray(numArray) {
    return Math.max.apply(null, numArray);
  }

  function cardHeight() {
    if ($cards.length) {
      $cards.find('.card-body').removeAttr('style');

      if (responsive.matches) {
        heights = [];

        for (let i = 0; i < $cards.length; i += 1) {
          const card = $cards[i];
          heights.push($(card).find('.card-body').height());
        }

        $cards.find('.card-body').height(getMaxOfArray(heights));
      }
    }
  }

  function resizeRecalc() {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      cardHeight();
    }, RESIZE_DEBOUNCE_INTERVAL);
  }

  cardHeight();

  $(window).resize(resizeRecalc);
  window.addEventListener('orientationchange', resizeRecalc, false);
});

export default enable;
